import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=6a01eabc&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.css?vue&type=style&index=0&id=6a01eabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01eabc",
  null
  
)

export default component.exports